import React from "react";
import { cn } from "../lib/utils";

export const H3: React.FC<React.HTMLAttributes<HTMLHeadingElement>> = ({
  children,
  className,
  ...props
}) => (
  <h3
    className={cn(
      "font-display scroll-m-20 text-2xl tracking-tight",
      className,
    )}
    {...props}
  >
    {children}
  </h3>
);
